module.exports = __webpack_public_path__ + "media/images/riders/DEFAULT-2b5d1645393fd6c0ebf882d23c8489cf.jpg";